const copyElements = document.querySelectorAll('.js-copy');

if (copyElements.length) {
    for (const copyElement of copyElements) {
        copyElement.addEventListener("click", (e) => {
            const copyText = copyElement.getAttribute('data-copy');
            const copiedMessage = copyElement.getAttribute('data-copied-message');
    
            if (copyText) {
                const textArea = document.createElement("textarea");
                textArea.value = copyText;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
    
                copyElement.parentElement.style.borderColor = '#22d4d3';
                if (copiedMessage) {
                    const couponValueEl = copyElement.parentElement.querySelector('.product-coupon__code-value');
                    if (couponValueEl) {
                        couponValueEl.innerText = copiedMessage
                        setTimeout(() => {
                            couponValueEl.innerText = copyText
                        }, 3000)
                    }
                }
            }
        })
    }
}
